var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 7C16.4 6.07003 16.4 5.60504 16.2978 5.22354C16.0204 4.18827 15.2118 3.37962 14.1765 3.10222C13.795 3 13.33 3 12.4 3C11.4701 3 11.0051 3 10.6236 3.10222C9.58829 3.37962 8.77965 4.18827 8.50225 5.22354C8.40002 5.60504 8.40002 6.07003 8.40002 7M5.60002 21H19.2C20.3201 21 20.8802 21 21.308 20.782C21.6843 20.5903 21.9903 20.2843 22.182 19.908C22.4 19.4802 22.4 18.9201 22.4 17.8V10.2C22.4 9.07989 22.4 8.51984 22.182 8.09202C21.9903 7.71569 21.6843 7.40973 21.308 7.21799C20.8802 7 20.3201 7 19.2 7H5.60002C4.47992 7 3.91987 7 3.49204 7.21799C3.11572 7.40973 2.80976 7.71569 2.61801 8.09202C2.40002 8.51984 2.40002 9.07989 2.40002 10.2V17.8C2.40002 18.9201 2.40002 19.4802 2.61801 19.908C2.80976 20.2843 3.11572 20.5903 3.49204 20.782C3.91987 21 4.47992 21 5.60002 21Z",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase01);
export default __webpack_public_path__ + "static/media/briefcase-01.de799af379c534601feb3a75d3cd9e17.svg";
export { ForwardRef as ReactComponent };